import { NavLink } from "react-router-dom";
import { X, Users, UserCircle2 } from "lucide-react";
import { useAuth } from "../auth/AuthContext";
import { ADMIN_NAV, allowedModules } from "../config/modules";

const LOGO = "https://storage.googleapis.com/lsp-webstore/Dashboard/redlogo.jpeg";

function Sidebar({ sidebarOpen, setSidebarOpen }) {
  const { user } = useAuth();
  const close = () => setSidebarOpen(false);
  const modules = allowedModules(user);

  return (
    <aside
      className={`fixed lg:static top-0 left-0 h-full w-64 bg-white border-r border-gray-200 z-50 flex flex-col
        transform transition-transform duration-200 lg:translate-x-0
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}`}
    >
      <div className="h-[72px] px-5 flex items-center justify-between border-b border-gray-200">
        <div className="flex items-center gap-3 min-w-0">
          <img src={LOGO} alt="Lightspeed Photonics" className="h-9 object-contain" />
        </div>
        <button onClick={close} className="lg:hidden text-gray-500" aria-label="Close menu">
          <X size={20} />
        </button>
      </div>

      <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-0.5">
        <p className="px-3 pb-2 text-[11px] font-semibold uppercase tracking-wider text-gray-400">Workspace</p>
        {modules.map((m) => (
          <NavItem key={m.key} to={m.path} icon={<m.icon size={17} />} label={m.label} onClick={close} />
        ))}

        {user.role === "admin" && (
          <>
            <p className="px-3 pt-5 pb-2 text-[11px] font-semibold uppercase tracking-wider text-gray-400">Administration</p>
            <NavItem to={ADMIN_NAV.path} icon={<Users size={17} />} label={ADMIN_NAV.label} onClick={close} />
          </>
        )}
      </nav>

      <div className="px-3 py-3 border-t border-gray-200">
        <NavItem to="/dashboard/profile" icon={<UserCircle2 size={17} />} label="My Account" onClick={close} />
        <p className="px-3 pt-2 text-[11px] text-gray-400">© Lightspeed Photonics</p>
      </div>
    </aside>
  );
}

function NavItem({ to, icon, label, onClick }) {
  return (
    <NavLink
      to={to}
      end={to === "/dashboard"}
      onClick={onClick}
      className={({ isActive }) =>
        `relative flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
          isActive
            ? "bg-red-50 text-[#C00000] font-medium before:absolute before:left-0 before:top-2 before:bottom-2 before:w-[3px] before:rounded-full before:bg-[#C00000]"
            : "text-gray-600 hover:bg-gray-50 hover:text-[#111111]"
        }`
      }
    >
      {icon}
      <span>{label}</span>
    </NavLink>
  );
}

export default Sidebar;
